import moment from 'moment'
import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './edit-matches.jade'
import {Match, Season} from '../../models'
import '../seasons'

@Component('sporty')
@Template(template) @Attribute('season', Season)
export default class EditMatches extends HTMLElement {
  attached() {
    this.load()
  }

  seasonChange() {
    this.load()
  }

  changeSeason({season}) {
    this.season = season
  }

  load() {
    Match.load({seasons: [this.season._id]})
      .then(data => {
        this.realMatches = data.matches
        this.render()
      })
  }

  flash(match) {
    match.$justSaved = true
    this.render()
    setTimeout(() => {
      match.$justSaved = false
      this.render()
    }, 500)
  }

  saveRound(match, e) {
    if(match.round == e.target.value) return
    match.round = e.target.value
    return match.save().then(() => this.flash(match))
  }

  saveDate(match, e) {
    if(!e.target.value) return
    var value = e.target.value.split('-')
    value = moment(match.startTime)
      .year(+value[0])
      .month(+value[1] - 1)
      .date(+value[2])
      .toISOString()
    if(value == match.startTime) return
    match.startTime = value
    match.save().then(() => this.flash(match))
  }

  saveTime(match, e) {
    if(!e.target.value) return
    var value = e.target.value.split(':')
    value = moment(match.startTime)
      .hour(+value[0])
      .minute(+value[1])
      .toISOString()
    if(value == match.startTime) return
    match.startTime = value
    return match.save().then(() => this.flash(match))
  }
}
